import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { debounceTime } from 'rxjs';
import { SearchBoxComponent } from 'src/app/dashboard/components/search-box/search-box.component';
import { TabelPaging } from 'src/app/dashboard/interfaces/table';
import { PCTableActionInputModel } from 'src/app/dashboard/models/pc-table-action-input-model';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from 'src/app/dashboard/models/pc-table-input-model';
import { UserProfile } from 'src/app/dashboard/models/user-profile';
import { CustomizeResponseService } from 'src/app/dashboard/services/customize-response.service';
import { UserApiService } from 'src/app/dashboard/services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { DataService } from 'src/app/services/data.service';
import { LoggerService } from 'src/app/services/logger.service';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { TourService } from 'src/app/services/tour.service';

declare var bootstrap: any;

@Component({
  selector: '.app-dashboard-layout.layout-wrapper.layout-content-navbar',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.css'],
})
export class DashboardLayoutComponent implements OnInit {
  public isDarkMode: boolean;
  public thisUser: UserProfile;
  public isAdmin: boolean;
  public isRTL: boolean;
  public backendDateTime?: string;

  public sumBalance: number = 0;
  public sumCredit: number = 0;

  constructor(
    public tourService: TourService,
    private apiService: UserApiService,
    private logger: LoggerService,
    private dataService: DataService,
    private router: Router,
    public calendarService: NewCalendarService,
    private cookieService: CookieService
  ) {
    this.thisUser = new UserProfile();
    this.isRTL = true;
    this.thisUser.imageurl = '../../assets/img/avatars/no-image.png';

    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
      ],
      'List of invoices',
      []
    );

    if (document.getElementsByClassName('dark-style').length > 0) {
      this.isDarkMode = true;
    } else {
      this.isDarkMode = false;
    }
    this.isAdmin = false;

    this.GetMe();
  }

  public action: PCTableActionInputModel;
  public loading: boolean = true;

  public checkNotification: any[] = [];
  public checkShow: boolean = false;
  public accessCheckNotification: boolean = true;

  public needToBuyNotification: any[] = [];
  public needToBuyShow: boolean = false;
  public accessNeedToBuyNotification: boolean = true;

  public changePriceNotification: any[] = [];
  public changePriceShow: boolean = false;
  public changePriceLoading: boolean = false;
  public accessChangePriceNotification: boolean = true;

  public expireNotification: any[] = [];
  public expireShow: boolean = false;
  public accessExpireNotification: boolean = true;

  public apiResponse: any[] = [];
  public unreadCount: number = 0;
  public shouldAnimate: boolean = false;
  public isBatteryActive: boolean = false;

  @ViewChild('changePrice') changePrice!: ElementRef;
  @ViewChild('changePriceButton') changePriceButton!: ElementRef;

  @ViewChild('InventoryBuyNeed') InventoryBuyNeed!: ElementRef;
  @ViewChild('InventoryBuyNeedButton') InventoryBuyNeedButton!: ElementRef;

  @ViewChild('check') check!: ElementRef;
  @ViewChild('checkButton') checkButton!: ElementRef;

  @ViewChild('InventoryExpire') InventoryExpire!: ElementRef;
  @ViewChild('InventoryExpireButton') InventoryExpireButton!: ElementRef;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    const elementOnClick = event.target;
    if (this.changePrice != null) {
      if (
        !this.changePrice.nativeElement.contains(elementOnClick) &&
        !this.changePriceButton.nativeElement.contains(elementOnClick)
      ) {
        this.changePriceShow = false;
      }
    }
    if (this.InventoryBuyNeed != null) {
      if (
        !this.InventoryBuyNeed.nativeElement.contains(elementOnClick) &&
        !this.InventoryBuyNeedButton.nativeElement.contains(elementOnClick)
      ) {
        this.needToBuyShow = false;
      }
    }
    if (this.check != null) {
      if (
        !this.check.nativeElement.contains(elementOnClick) &&
        !this.checkButton.nativeElement.contains(elementOnClick)
      ) {
        this.checkShow = false;
      }
    }
    if (this.InventoryExpire != null) {
      if (
        !this.InventoryExpire.nativeElement.contains(elementOnClick) &&
        !this.InventoryExpireButton.nativeElement.contains(elementOnClick)
      ) {
        this.expireShow = false;
      }
    }
  }

  public ngOnInit(): void {
    //this.getCredit();
    this.fetchDataCheck();
    this.fetchDataNeedToBuy();
    this.fetchDataExpire();
    this.fetchChangePrice();
    var isAdminStorage: any = localStorage.getItem('isAdmin');
    if (isAdminStorage == null) {
      this.router.navigate(['']);
      return;
    }

    if (isAdminStorage != 'true' && isAdminStorage != 'false') {
      this.router.navigate(['']);
    }

    this.isAdmin = localStorage.getItem('isAdmin') == 'true';

    var cultureCookieValue = this.cookieService.get('Culture');
    if (cultureCookieValue == '') {
      this.cookieService.set('Culture', 'fa-IR');
      cultureCookieValue = 'fa-IR';
    }

    if (cultureCookieValue == 'fa-IR') {
      this.isRTL = true;
    } else {
      this.isRTL = false;
    }
  }

  public ngAfterViewInit(): void {
    const offcanvasElement = document.getElementById('InventorySellNeed');
    if (offcanvasElement) {
      const offcanvas = new bootstrap.Offcanvas(offcanvasElement);

      offcanvasElement.addEventListener('shown.bs.offcanvas', () => {
        this.isBatteryActive = true;
      });

      offcanvasElement.addEventListener('hidden.bs.offcanvas', () => {
        this.isBatteryActive = false;
      });
    }
  }

  public ngOnDestroy(): void {
    const offcanvasElement = document.getElementById('InventorySellNeed');
    if (offcanvasElement) {
      offcanvasElement.removeEventListener('shown.bs.offcanvas', () => {
        this.isBatteryActive = true;
      });

      offcanvasElement.removeEventListener('hidden.bs.offcanvas', () => {
        this.isBatteryActive = false;
      });
    }
  }

  public startTour() {
    this.tourService.startTour();
  }

  public closeItem(item: any, id: number) {
    this.apiResponse?.splice(id, 1);
    if (!item.isRead) {
      this.submitEdit(item);
    }
  }

  public submitEdit(inputElement: any) {
    try {
      this.loading = true;

      const url = `Notification/SetRead/${inputElement.id}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.unreadCount--;
            this.logger.addInfo(
              'وضعیت اعلان به دیده شده تغییر پیدا کرد',
              false
            );
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public clearList() {
    this.apiResponse = [];
  }

  public GetMe() {
    try {
      let url = `Account/GetMe`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get Single Item`);

          if (result == null) {
            this.logger.addWarning('errorMessage.NotRecievedUserInfo', false);
            return;
          }
          this.backendDateTime = result.dateTime;
          this.thisUser = result.data;

          this.dataService.setData(result.data, 'UserInformation');

          this.thisUser.imageurl = this.apiService.fixImage(
            this.thisUser.imageurl
          );
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (error) {
      this.logger.addException(error, true);
    }
  }

  public fetchDataNeedToBuy() {
    try {
      this.loading = true;

      let url = `Inventory/NeedToByNotifications`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);

          if (result.succeeded) {
            //this.needToBuyNotification = result.data ?? [];
            this.needToBuyNotification = result.data ? result.data : [];
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.accessNeedToBuyNotification =
            this.apiService.AddErrorLogItemAccess(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public fetchDataCheck() {
    try {
      this.loading = true;

      let url = `Check/Notifications`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);

          if (result.succeeded) {
            //this.checkNotification = result.data ?? [];
            this.checkNotification = result.data ? result.data : [];
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.accessCheckNotification =
            this.apiService.AddErrorLogItemAccess(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public fetchDataExpire() {
    try {
      this.loading = true;

      let url = `InventoryDetail/CloseToExpireNotifications`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);

          if (result.succeeded) {
            //this.expireNotification = result.data ?? [];
            this.expireNotification = result.data ? result.data : [];
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.accessExpireNotification =
            this.apiService.AddErrorLogItemAccess(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public fetchChangePrice() {
    try {
      this.loading = true;

      let url = `DrugStoreNotification/GetAllNotification`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);

          if (result.succeeded) {
            this.changePriceNotification = result.data ? result.data : [];
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.accessChangePriceNotification =
            this.apiService.AddErrorLogItemAccess(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public acceptChangePrice(element: any, index: number) {
    try {
      this.changePriceLoading = true;

      const editUrl = `DrugStoreNotification/AcceptNotification/${element.id}`;
      this.apiService.getSingleItem(new ApiRequestModel(editUrl)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.changePriceNotification.splice(index, 1);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.changePriceLoading = false;
        },
        () => {
          this.changePriceLoading = false;
          console.log(`Completed!`);
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.changePriceLoading = false;
    }
  }

  public rejectChangePrice(element: any, index: number) {
    try {
      this.changePriceLoading = true;

      const editUrl = `DrugStoreNotification/RejectNotification/${element.id}`;
      this.apiService.getSingleItem(new ApiRequestModel(editUrl)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.changePriceNotification.splice(index, 1);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.changePriceLoading = false;
        },
        () => {
          this.changePriceLoading = false;
          console.log(`Completed!`);
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.changePriceLoading = false;
    }
  }

  public readChangePrice(element: any, index: number) {
    try {
      this.changePriceLoading = true;

      const editUrl = `DrugStoreNotification/IsReadNotification/${element.id}`;
      this.apiService.getSingleItem(new ApiRequestModel(editUrl)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.changePriceNotification.splice(index, 1);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.changePriceLoading = false;
        },
        () => {
          this.changePriceLoading = false;
          console.log(`Completed!`);
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.changePriceLoading = false;
    }
  }
}
